export const sr = {
  Header: {
    title: 'Сагласност на садржину и изглед печата',
    titleShort: 'ePecat',
    Labels: {
      homePage: 'Почетна страна',
      roles: 'Улоге корисника',
      adminPanel: 'Админ панел',
      users: 'Корисници',
      decision: 'Решења',
      decisionLink:
        'Решења о захтевима за давање сагласности на садржину и изглед печата',
      decisionType: 'Тип решења',
      signet: 'Печати',
      codebooks: 'Шифарници',
      services: 'Услуге',
      requests: 'Захтеви',
      requestForSignetApproval:
        'Захтев за давање сагласности на садржину и изглед печата',
      requestForSignetStatus: 'Пријава промене статуса печата',
      signetInfo: 'Информације о печату',
      signetLink: 'Достављање података о израђеним печатима',
      kjs: 'Преглед КЈС',
      place: 'Преглед градова\\општина',
      municipality: 'Преглед седишта органа',
      documents: 'Документи',
      elSignetPreview: 'Преглед спољног приказа електронског печата',
      instruction: 'Упутство',
      NotificationMessages: {
        instruction: 'Корисничко упутство',
        unsuccessDownload: 'Дошло је до грешке приликом преузимања документа',
      },
    },

    Buttons: {
      signIn: 'Пријава',
      signOut: 'Одјави се',
    },
  },

  Footer: {
    title: 'Портал еУправа Републике Србије',
    Buttons: {
      toTop: 'Врх стране',
    },
    text:
      'Веб презентација је лиценцирана под условима лиценце Creative Commons Ауторство-Некомерцијално-Без прераде 3.0 Србија. Веб пројекат',
    linkText: 'Услови коришћења',
  },

  SearchFilter: {
    placeholder: 'Претрага...',
  },

  LoadingIndicator: {
    syncKjsMessage: 'Тренутно је у току синхронизација КЈС-a.',
    syncKjsAdditionalMessage: 'Молимо Вас сачекајте.',
  },

  Global: {
    Button: {
      save: 'Сачувај',
      edit: 'Измени',
      delete: 'Обриши',
      deactivate: 'Деактивирај',
      goBack: 'Врати назад',
      quit: 'Одустани',
      print: 'Одштампај',
      yes: 'ДА',
      no: 'НЕ',
      confirm: 'У реду',
      toLandingPage: 'Повратак на почетну страницу',
    },
    EnhancedTable: {
      rowPerPage: 'Број редова:',
      of: ' од ',
    },
    Lang: {
      sr: 'Ћирилица',
      lat: 'Latinica',
    },
    NotificationMessages: {
      errorTitle: 'Грешка',
      errorMessage: 'Токен је истекао',
    },
  },

  Enums: {
    Role: {
      superAdmin: {
        text: 'Супер администратор',
        value: 'superAdmin',
      },
      admineu: {
        text: 'Администратор КЕУ',
        value: 'admineu',
      },
      adminmduls: { text: 'Администратор МДУЛС-а и АП-а', value: 'adminmduls' },
      olMduls: { text: 'Обрађивач МДУЛС-а и АП-а', value: 'olMduls' },
      olOrgana: { text: 'Овлашћено лице органа', value: 'olOrgana' },
      inspektorat: {
        text: 'Овлашћено лице Управног инспектората',
        value: 'inspektorat',
      },
    },
    DecisionStatus: {
      IN_PREPARATION: {
        text: 'У изради',
        // color: 'green',
      },
      SENT: {
        text: 'Послато',
        // color: 'yellow',
      },
      SENT_AGAIN: {
        text: 'Поново послато',
        // color: 'purple',
      },
      VERIFIED: {
        text: 'Потписано',
        // color: 'blue',
      },
      DELIVERY_ACCEPTED: {
        text: 'Прихваћена достава',
        // color: 'blue',
      },
      REJECTED: {
        text: 'Одбијено',
        // color: 'aqua',
      },
      DELIVERED_WITHOUT_TAKEOVER: {
        text: 'Достављено без преузимања',
        // color: 'orange',
      },
      DELIVERED: {
        text: 'Достављено',
        // color: 'olive',
      },
      FINAL: {
        text: 'Правоснажно',
        // color: 'red',
      },
      SUSPENDED: {
        text: 'Сторнирано',
        // color: 'lime',
      },
    },

    DecisionStatusList: [
      { value: 'IN_PREPARATION' },
      { value: 'SENT' },
      { value: 'SENT_AGAIN' },
      { value: 'DELIVERY_ACCEPTED' },
      { value: 'REJECTED' },
      { value: 'DELIVERED_WITHOUT_TAKEOVER' },
      { value: 'DELIVERED' },
      { value: 'FINAL' },
      { value: 'SUSPENDED' },
    ],

    SignetStatus: {
      APPROVED: {
        text: 'Одобрен',
        value: 'APPROVED',
      },
      REJECTED: {
        text: 'Одбијен',
        value: 'REJECTED',
      },
      COMPLEMENT_REQUIRED: {
        text: 'Потребна допуна',
        value: 'COMPLEMENT_REQUIRED',
      },
      COMPLEMENTED: {
        text: 'Допуњен',
        value: 'COMPLEMENTED',
      },
      LOST: {
        text: 'Изгубљен',
        value: 'LOST',
      },
      TERMINATED: {
        text: 'Престао да важи',
        value: 'TERMINATED',
      },
      COMPROMISED: {
        text: 'Компромитован',
        value: 'COMPROMISED',
      },
      NOT_CONSENTED: {
        text: 'Није добијена сагласност',
        value: 'NOT_CONSENTED',
      },
      DELIVERED: {
        text: 'Достављен',
        value: 'DELIVERED',
      },
      FINISHED: {
        text: 'Завршен',
        value: 'FINISHED',
      },
      REVOKED: {
        text: 'Опозван',
        value: 'REVOKED',
      },
      CANCELED: {
        text: 'Сторниран',
        value: 'CANCELED',
      },
    },

    SignetState: {
      IN_USE: {
        text: 'У употреби',
        value: 'IN_USE',
      },
      OUT_OF_USE: {
        text: 'Ван употребе',
        value: 'OUT_OF_USE',
      },
      READY_TO_USE: {
        text: 'Спреман за употребу',
        value: 'READY_TO_USE',
      },
    },

    Status: {
      IN_PREPARATION: {
        text: 'У припреми',
        value: 'IN_PREPARATION',
      },
      SUBMIT: {
        text: 'Поднет',
        value: 'SUBMIT',
      },
      WITHDRAWN: {
        text: 'Повучен',
      },
      IN_PROCESSING: {
        text: 'У обради',
      },
      REQUIRED_COMPLEMENTATION: {
        text: 'Потребна допуна',
        value: 'REQUIRED_COMPLEMENTATION',
      },
      COMPLEMENTED: {
        text: 'Допуњен',
        value: 'COMPLEMENTED',
      },
      ACCEPTED: {
        text: 'Одобрен',
      },
      REJECTED: {
        text: 'Одбачен',
      },
      REFUSE: {
        text: 'Одбијен',
      },
      CANCELED: {
        text: 'Сторниран',
      },
      COMPLETED: {
        text: 'Завршен',
      },
      ARCHIVED: {
        text: 'Архивиран',
      },
    },

    CoatOfArmsAppearance: {
      LARGE_RS: {
        text: 'Велики ГРБ РС',
        value: 'LARGE_RS',
      },
      SMALL_RS: {
        text: 'Мали ГРБ РС',
        value: 'SMALL_RS',
      },
      TRADITIONAL_APV: {
        text: 'Мали ГРБ РС, Грб АПВ и традиционални грб АПВ',
        value: 'TRADITIONAL_APV',
      },
    },

    NationalMinorities: {
      CRNOGORCI: {
        text: 'ЦРНОГОРСКИ',
        value: 'CRNOGORCI',
      },
      HRVATI: {
        text: 'ХРВАТСКИ',
        value: 'HRVATI',
      },
      BUNJEVCI: {
        text: 'БУЊЕВАЧКИ',
        value: 'BUNJEVCI',
      },
      BUGARI: {
        text: 'БУГАРСКИ',
        value: 'BUGARI',
      },
      BOSNJACI: {
        text: 'БОСАНСКИ',
        value: 'BOSNJACI',
      },
      MADJARI: {
        text: 'МАЂАРСКИ',
        value: 'MADJARI',
      },
      ROMI: {
        text: 'РОМСКИ',
        value: 'ROMI',
      },
      RUMUNI: {
        text: 'РУМУНСКИ',
        value: 'RUMUNI',
      },
      RUSINI: {
        text: 'РУСИНСКИ',
        value: 'RUSINI',
      },
      SLOVACI: {
        text: 'СЛОВАЧКИ',
        value: 'SLOVACI',
      },
      ALBANCI: {
        text: 'АЛБАНСКИ',
        value: 'ALBANCI',
      },
      VLASI: {
        text: 'ВЛАШКИ',
        value: 'VLASI',
      },
      CESI: {
        text: 'ЧЕШКИ',
        value: 'CESI',
      },
      MAKEDONCI: {
        text: 'МАКЕДОНСКИ',
        value: 'MAKEDONCI',
      },
    },

    Users: {
      admin: {
        text: 'Админ',
        value: 'admin',
      },
      olmduls: {
        text: 'Овлашћено лице МДУЛС-а',
        value: 'olmduls',
      },
      olorgana: {
        text: 'Овлашћено лице органа',
        value: 'olorgana',
      },
      olorganaAP: {
        text: 'Овлашћено лице органа АП',
        value: 'olorganaAP',
      },
      olmdulsAP: {
        text: 'Овлашћено лице МДУЛС-а АП',
        value: 'olmdulsAP',
      },
    },

    DecisionTypeTypes: [
      {
        text: 'Електронски формат',
        value: 'DIGITAL_SIGNET',
      },
      {
        text: 'Формат отиска',
        value: 'IMPRINT_SIGNET',
      },
      {
        text: 'Електронски формат за АП',
        value: 'DIGITAL_SIGNET_AP',
      },
    ],

    AutonomousProvince: [
      {
        text: 'Војводина',
        value: 'VOJVODINA',
        valueForFilter: 0,
      },
      {
        text: 'Косово и Метохија',
        value: 'KOSOVO_I_METOHIJA',
        valueForFilter: 1,
      },
      {
        text: 'Ништа од наведеног',
        value: null,
        valueForFilter: null,
      },
    ],
  },

  Instruction: {
    instruction: 'Корисничко упутство',
    content: 'Овде можете преузети корисничко упутство.',
    tooltip: 'Преузмите корисничко упутство',
    NotificationMessages: {
      instruction: 'Корисничко упутство',
      unsuccessDownload: 'Дошло је до грешке приликом преузимања документа',
    },
  },

  RoleList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },
  RoleTable: {
    HeaderColumns: {
      roleName: 'Име улоге',
      actions: 'Акције',
      delete: 'Брисање',
    },
    titleTable: 'Улоге корисника',
  },

  RoleRow: {
    ConfirmDialog: {
      confirmMessage: 'Да ли сте сигурни да желите да обришете ролу?',
      confirmDelete: '',
    },
  },
  SignetTable: {
    HeaderColumns: {
      request: 'Деловодни број предмета',
      uniqueNumber: 'Јединствени серијски број',
      organizationalUnit: 'Орган',
      plannedStart: 'Датум почетка употребе',
      statusChangedDate: 'Датум промене статуса',
      authorizedPerson: 'Овлашћено лице',
      signetState: 'Стање',
      signetStatus: 'Статус',
      processing: 'Обрада',
    },
    titleTable: 'Евиденција печата',
  },
  ModalForUpdateRole: {
    Labels: {
      title: 'Измена роле',
    },
    Placeholders: {
      roleName: 'Назив роле',
      ActionsTable: {
        allActionsListTitle: 'Листа свих акција',
        chosenActionsListTitle: 'Листа изабраних акција',
        selectAllActions: 'Обележи све акције',
      },
    },
    Errors: {
      roleNameEmpty: 'Потребно је унети назив роле.',
    },
  },
  ModalForAddRole: {
    Errors: {
      roleNameEmpty: 'Не може да буде празно име',
    },
    Labels: {
      title: 'Наслов',
    },
    Placeholders: {
      roleName: 'Назив роле',
      ActionsTable: {
        allActionsListTitle: 'Листа свих акција',
        chosenActionsListTitle: 'Листа изабраних акција',
        selectAllActions: 'Обележи све акције',
      },
    },
  },
  DecisionList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  SignetList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  DecisionTable: {
    Labels: {
      titleTable: 'Решења',
    },
    HeaderColumns: {
      requestForSignetApproval: 'Деловодни број предмета',
      decisionStatus: 'Статус',
      decisionType: 'Тип решења',
      dateCreated: 'Датум креирања',
      download: 'Преузимање',
      edit: 'Измена',
      delete: 'Брисање',
    },
    Tooltips: {
      addNew: 'Додај ново решење',
    },
  },

  DecisionRow: {
    ConfirmDialog: {
      confirmMessage: 'Да ли желите да обришете решење?',
      confirmDelete: ', обриши!',
    },
    NotificationMessages: {
      decisionFinalTitle: 'Решење',
      decisionTitleError: 'Грешка',
      successDownload: 'Успешно сте преузели документ',
      unsuccessDownload: 'Дошло је до грешке приликом преузимања документа',
    },
  },

  ModalForDecisionUpdateAndPreview: {
    Labels: {
      title: 'Преглед решења',
    },
    Errors: {
      decisionType: 'Тип решења је обавезно поље',
    },
    Placeholders: {
      decisionStatus: 'Статус',
      dateCreated: 'Датум креирања',
      decisionType: 'Тип решења',
    },
  },

  ModalForAddSubmissionDataSignet: {
    Labels: {
      title: 'Достављање података о израђеним печатима',
      titleLook: 'Спољни приказ електронског печата',
      titleDestroyed: 'Записник о уништењу печата',
    },
    Errors: {
      uniqueSerialNumber: 'Потребно је унети јединствен серијски број',
      plannedStart: 'Потребно је унети почетак важења',
      validUntil: 'Потребно је унети датум важења',
      invalidValidUntil: 'Датум почетка важења мора бити мањи од рока важења',
      imageNotUploaded: 'Фајл није учитан',
      invalidFileSize: 'Величина фајла је већа од 10MB',
      invalidFormat: 'Фајл мора да буде у .pdf или .docx формату',
      beginOfUsage: 'Потребно је унети датум почетка употребе',
    },
    Placeholders: {
      uploadSignetLook: 'Учитајте изглед печата',
      uploadSignetDestroyed: 'Учитајте записник о уништењу печата',
      uniqueSerialNumber: 'Јединствени серијски број',
      plannedStart: 'Датум набавке',
      validUntil: 'Датум важења',
      questionDestroyedAttachment: 'Приложити записник о уништењу печата?',
      validPeriod: 'Рок важења',
      validPeriodInfo: 'Рок важења је у годинама',
      beginOfUsage: 'Почетак употребе',
    },
  },

  ModalForAddComplementRequestApproval: {
    Labels: {
      title: 'Допуна захтева за давање сагласности на садржину и изглед печата',
    },
    Errors: {
      description: 'Потребно је унети образложење',
      descriptionLength: 'Опис може садржати највише 2000 карактера',
    },
    Placeholders: {
      description: 'Унесите образложење...',
      descriptionForPreview: 'Захтев за допуну',
    },
  },

  ModalForAddComplementSignet: {
    Labels: {
      title: 'Допуна захтева за достављање података о израђеним печатима',
    },
    Errors: {
      description: 'Потребно је унети образложење',
      descriptionLength: 'Опис може садржати највише 2000 карактера',
    },
    Placeholders: {
      description: 'Унесите образложење...',
      descriptionForPreview: 'Захтев за допуну',
    },
  },

  UploadFormTable: {
    name: 'Назив',
    delete: 'Обриши',
    messageMultiple: 'Потребно је учитати све неопходне фајлове одједном',
    messageSingle: 'Омогућено је учитавање само једног фајла',
  },

  ModalForAddUser: {
    Labels: {
      title: 'Додавање новог корисника',
    },
    Errors: {
      umcn: 'Потребно је унети ЈМБГ.',
      firstName: 'Потребно је унети име.',
      lastName: 'Потребно је унети презиме.',
      username: 'Потребно је унети имејл.',
      kjs: 'Потребно је унети КЈС.',
    },
    Placeholders: {
      umcn: 'ЈМБГ',
      firstName: 'Име',
      lastName: 'Презиме',
      username: 'Имејл',
      telephone: 'Телефон (фиксни)',
      cellPhone: 'Телефон (мобилни)',
      phoneNumber: 'Број телефона',
      place: 'Град\\Општина',
      municipalities: 'Седиште органа',
      institutionType: 'Tип органа',
      institutionName: 'Назив органа',
      kjs: 'KJС',
      role: 'Рола',
      pib: 'ПИБ',
      uniqueKjsNumber: 'Јединствени број КЈС',
    },
    NotificationMessages: {
      userTitle: 'Корисник',
      umcnError: 'Корисник са унетим ЈМБГ-ом већ постоји у бази података!',
      invalidUmcnError: 'Унели сте невалидан ЈМБГ!',
      errorTitle: 'Грешка',
      usernameError:
        'Корисник са унетим корисничким именом већ постоји у бази података!',
      umcnAndUsernameError:
        'Корисник са унетим ЈМБГ-ом и корисничким именом већ постоји у бази података!',
      creationSuccessMessage: 'Корисник је успешно креиран',
    },
    Tooltips: {
      addItem: 'Додај КЈС',
    },
  },

  ModalForUpdateUser: {
    Labels: {
      title: 'Измена података о кориснику',
    },
    Errors: {
      umcn: 'Потребно је унети ЈМБГ.',
      firstName: 'Потребно је унети име.',
      lastName: 'Потребно је унети презиме.',
      username: 'Потребно је унети имејл.',
      kjs: 'Потребно је унети КЈС.',
    },
    Placeholders: {
      umcn: 'ЈМБГ',
      firstName: 'Име',
      lastName: 'Презиме',
      username: 'Имејл',
      phoneNumber: 'Број телефона',
      telephone: 'Телефон (фиксни)',
      cellPhone: 'Телефон (мобилни)',
      place: 'Град\\Општина',
      municipalities: 'Седиште органа',
      institutionType: 'Tип органа',
      institutionName: 'Назив органа',
      kjs: 'KJС',
      role: 'Рола',
      pib: 'ПИБ',
      uniqueKjsNumber: 'Јединствени број КЈС',
    },
    NotificationMessages: {
      errorTitle: 'Грешка',
      userTitle: 'Корисник',
      updateSuccessMessage: 'Корисник је успешно измењен',
    },
    Tooltips: {
      addItem: 'Додај КЈС',
    },
    ConfirmDialog: {
      deleteKjsMunicipality: 'Да ли заиста желите да обришете КЈС?',
    },
  },

  UserList: {
    rowPerPage: 'Број редова на страници',
    of: ' од ',
  },

  UserTable: {
    HeaderColumns: {
      firstName: 'Име',
      lastName: 'Презиме',
      username: 'Имејл',
      active: 'Активан',
      activateDeactivate: 'Активирај / Деактивирај',
      edit: 'Измена',
    },
    titleTable: 'Корисници',
  },

  UserRow: {
    Tooltips: {
      activate: 'Активирај корисника',
      deactivate: 'Деактивирај корисника',
    },
    ConfirmDialog: {
      deactivateUserMessage:
        'Да ли желите да деактивирате изабраног корисника?',
      activateUserMessage: 'Да ли желите да активирате изабраног корисника?',
      deactivate: ', деактивирај!',
      activate: ', активирај!',
    },
  },

  RequestForSignetApprovalForm: {
    title: ' Захтев за давање сагласности на садржину и изглед печата',
    Buttons: {
      back: 'Назад',
      next: 'Настави',
      quit: 'Одустани',
      save: 'Сачувај',
      saveFinalStep: 'Сачувај захтев',
      submit: 'Поднеси захтев',
    },
    ConfirmDialog: {
      confirmMessage: 'Да ли желите да одустанете од креирања захтева?',
      confirmDelete: ', одустани!',
    },
    Errors: {
      placeEmpty: 'Потребно је одабрати град\\општину',
      municipalityEmpty: 'Потребно је одабрати седиште органа',
      institutionTypeEmpty: 'Потребно је одабрати тип органа',
      kjsEmpty: 'Потребно је одабрати КЈС',
      signetNumberEmpty: 'Потребно је унети број печата',
      coatOfArmsAppearanceEmpty: 'Потребно је одабрати грб',
      invalidFileSize: 'Величина прилога мора бити мања од 10MB',
      uploadedFilesEmpty: 'Потребно је учитати документе',
      invalidFormat: 'Фајл мора да буде у .pdf или .docx формату',
    },
    NotificationMessages: {
      requestTitle: 'Захтев',
      draftUnsuccess:
        'Проверите да ли су на адекватан начин попуњена сва обавезна поља',
    },
  },

  FirstStep: {
    Placeholders: {
      place: 'Град\\Општина',
      municipalities: 'Седиште органа',
      institutionType: 'Tип органа',
      institutionName: 'Назив органа',
      countryName: 'Назив државе',
      autonomousProvince: 'Назив територијалне припадности',
      organizationalUnits: 'Организационе јединице',
      organizationalUnit1: 'Организационa јединицa - ниво 1',
      organizationalUnit2: 'Организационa јединицa - ниво 2',
      organizationalUnit3: 'Организационa јединицa - ниво 3',
      organizationalUnitPlace: 'Седиште организационе јединице',
      identificationNumber: 'Матични број',
      uniqueNumber: 'Јединствени број КЈС',
      pib: 'ПИБ',
      kjs: 'KJС',
      referenceNumber: 'Деловодни број предмета',
    },
    Tooltips: {
      municipality: 'Унеси назив општине',
    },
  },
  SecondStep: {
    Placeholders: {
      coatOfArmsAppearance: 'Изглед грба',
      signetSizes: 'Величина печата',
      signetNumber: 'Број печата',
      ordinalNumber: 'Редни број',
      languageAndScript: 'Језик и писмо',
      nationalMinorities: 'Језик и писмо националних мањина',
    },
    Questions: {
      signetForm: 'Форма печата',
      signetScript:
        'Да ли се печат исписује на Српском језику, латиничном писму?',
      nationalMinorities:
        'Да ли се печат исписује на језику националних мањина?',
    },
    Choices: {
      digital: 'Електронски',
      imprintShape: 'Форма отиска',
    },
  },
  ThirdStep: {
    Placeholders: {
      note: 'Напомена уз захтев',
      upload: 'Учитајте прилоге',
    },
  },

  DecisionTypeList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  DecisionTypeTable: {
    HeaderColumns: {
      name: 'Име',
      description: 'Опис',
      preview: 'Преглед',
      edit: 'Измена',
      delete: 'Брисање',
    },
    Labels: {
      titleTable: 'Типови решења',
    },
    Tooltips: {
      addNew: 'Додај нови тип решења',
    },
  },

  DecisionTypeRow: {
    ConfirmDialog: {
      confirmMessage: 'Да ли желите да обришете тип решења?',
      confirmDelete: ', обриши!',
    },
  },

  ModalForAddDecisionType: {
    Labels: {
      title: 'Додавање новог типа решења',
      uploadDecision: '  Приложите тип решења',
      fileTitlePreview: '  Приложите тип решења...',
    },
    Errors: {
      name: 'Потребно је унети назив типа решења.',
      description: 'Потребно је унети опис типа решења.',
      invalidFileSize: 'Величина фајла је већа од 10MB',
      invalidFileFormat: 'Фајл није у docx формату',
      fileNotUploaded: 'Фајл није учитан',
      invalidFormat: 'Фајл мора да .docx формату',
    },
    Placeholders: {
      name: 'Назив',
      description: 'Опис',
    },
    Tooltips: {
      decisionAttachment: 'Приложите тип решења',
    },
  },

  ModalForAddPlaceToAutonomousProvince: {
    Labels: {
      title: 'Изаберите територијалну припадност',
    },
    Errors: {
      autonomousProvince: 'Потребно је изабрати територијалну припадност.',
    },
    Placeholders: {
      autonomousProvince: 'Територијална припадност',
    },
  },

  ModalForDecisionTypeUpdateAndPreview: {
    Labels: {
      title: 'Измена типа решења',
      uploadDecision: 'Приложите решење',
      fileTitlePreview: 'Преглед типа решења',
    },
    Errors: {
      name: 'Потребно је унети назив типа решења.',
      description: 'Потребно је унети опис типа решења.',
      invalidFileSize: 'Величина фајла је већа од 10MB',
      invalidFileFormat: 'Фајл није docx формату',
      fileNotUploaded: 'Фајл није учитан',
    },
    Placeholders: {
      name: 'Назив',
      description: 'Опис',
    },
    Tooltips: {
      editDecisionAttachment: 'Приложите нови тип решења',
    },
  },

  ModalForPreviewSubmissionDataSignet: {
    Labels: {
      title: 'Преглед достављених података о израђеним печатима',
      uploadDecision: '  Приложите документ',
      fileTitlePreview: '  Приложите документ...',
    },
    Placeholders: {
      uniqueSerialNumber: 'Јединствени серијски број',
      plannedStart: 'Важи од',
      validUntil: 'Важи до',
      description: 'Опис',
    },
    Tooltips: {
      editDecisionAttachment: 'Приложите нови тип решења',
    },
  },
  ModalForPreviewAttachmentSubmissionDataSignet: {
    Labels: {
      title: 'Преглед прилога',
      look: 'Величине и изгледа печата',
      destroyed: 'Записник о уништењу печата',
    },
    Placeholders: {
      look: 'Преглед величине и изгледа печата',
      destroyed: 'Преглед записника о уништењу печата',
    },
  },
  CheckboxGroupTwoChoices: {
    Labels: {
      choice1: 'Да',
      choice2: 'Не',
    },
  },

  RequestForSignetApprovalList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  RequestForSignetApprovalTable: {
    HeaderColumns: {
      kjsName: 'Институција',
      status: 'Статус захтева',
      placeAndMunicipality: 'Седиште органа',
      uniqueNumber: 'Јединствени број КЈС',
      identificationNumber: 'Матични број',
      pib: 'ПИБ',
      createdAt: 'Датум креирања',
      processing: 'Обрада',
      decisionStatus: 'Статус решења',
      clientsEmail: 'Имејл',
      note: 'Напомена',
    },
    Labels: {
      titleTable: 'Захтев за давање сагласности на садржину и изглед печата',
    },
    Tooltips: {
      addNew: 'Додај нови захтев',
      note: 'Преглед напомене',
      noteEmpty: 'Не постоји напомена',
    },
    NotificationMessages: {
      requestTitle: 'Захтев',
      draftSuccess: 'Захтев је успешно сачуван',
      submitSuccess: 'Захтев је успешно поднет',
    },
  },

  RequestForSignetApprovalRow: {
    ConfirmDialog: {
      confirmMessage: 'Да ли желите да обришете захтев?',
      confirmDelete: ', обриши!',
      confirmDecisionCreationMessage: 'Да ли желите да креирате решење?',
      confirmDecisionCreation: ', креирај!',
    },
  },

  ModalForAddDecision: {
    Labels: {
      title: 'Додавање новог решења',
      uploadDecision: '  Приложите решење',
      fileTitlePreview: '  Приложите решење...',
    },
    Errors: {
      decisionType: 'Тип решења је обавезно поље',
      fileNotUploaded: 'Фајл није учитан',
      invalidFormat: 'Фајл мора да буде у .pdf или .docx формату',
      invalidFileSize: 'Величина фајла је већа од 10MB',
    },
    Placeholders: {
      decisionType: 'Тип решења',
    },
    Tooltips: {
      decisionAttachment: 'Приложите решење',
    },
  },

  SignetFilter: {
    plannedStartFrom: 'Датум почетка употребе од',
    plannedStartTo: 'Датум почетка употребе до',
    signetState: 'Стање печата',
    signetStatus: 'Статус печата',
    requestForSignetApproval: 'Деловодни број предмета',
    uniqueSerialNumber: 'Јединствени серијски број',
    submitDateFrom: 'Датум креирања захтева од',
    submitDateTo: 'Датум креирања захтева до',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },

  Dashboard: {
    Email: {
      subject: 'Saglasnost za pečat - pristup',
      body:
        'Poštovani,%0D%0A%0D%0AIzmenama i dopunama Zakona o pečatu državnih i drugih organa ("Službeni glasnik RS", broj 101/2007 i 49/2021) predviđena je upotreba kvalifikovanog elektronskog pečata čime se omogućava izdavanje akata organa u elektronskom obliku.%0D%0AZahtev za saglasnost na elektronski pečat podnosi rukovodilac organa.%0D%0AUkoliko rukovodilac organa ovlasti neko drugo lice za podnošenje zahteva za elektronski pečat potrebno je da uz zahtev za registraciju, dostavite skenirano ovlašćenje rukovodioca organa za to lice.%0D%0A%0D%0APodaci o organu%0D%0A%0D%0ANaziv organa:%0D%0AGrad/Opština:%0D%0ASedište organa:%0D%0AJedinstveni broj KJS-a:%0D%0A%0D%0APodaci o ovlašćenom licu%0D%0A%0D%0AJMBG:%0D%0AIme:%0D%0APrezime:%0D%0AImejl:%0D%0A%0D%0ASkeniran dopis sa podacima o organu i ovlašćenom licu prosledite nam putem imejla epecat.mduls@mduls.gov.rs.',
    },
    Messages: {
      message1: 'Овде можете поднети ',
      messageBold:
        'Захтев за прибављање сагласности на садржину и изглед печата, ',
      message2: ' обавестити надлежни орган о промени статуса печата.',
      accessMessageQuestionPart: 'Немате приступ?',
      accessMessagePart: 'Обратите се администратору система ',
      linkMessage: ' овде.',
    },
    Buttons: {
      message: 'Поднеси захтев',
    },
  },

  RequestForSignetApprovalProcessingView: {
    Labels: {
      title: 'Обрада захтева',
      documentTitle: 'Документи',
      actionTitle: 'Акције',
      decisionTitle: 'Решење',
      previewTitle: 'Преглед захтева',
    },
    Placeholders: {
      place: 'Град\\Општина',
      municipality: 'Седиште органа',
      institutionType: 'Tип органа',
      institutionName: 'Назив органа',
      countryName: 'Назив државе',
      autonomousProvince: 'Назив територијалне припадности',
      organizationalUnit: 'Организациона јединица',
      identificationNumber: 'Матични број',
      uniqueNumber: 'Јединствени број КЈС',
      pib: 'ПИБ',
      kjs: 'KJС',
      referenceNumber: 'Деловодни број предмета',
      coatOfArmsAppearance: 'Изглед грба',
      signetSizes: 'Величина печата',
      numberOfSignets: 'Број печата',
      ordinalNumber: 'Редни број',
      languageAndScript: 'Језик и писмо',
      nationalMinorities: 'Језик и писмо националних мањина',
      note: 'Напомена уз захтев',
      signetForm: 'Форма печата',
      decisionStatus: 'Статус решења',
      status: 'Статус захтева',
      date: 'Креирање захтева',
      decisionCreationDate: 'Креирање решења',
    },
    Tooltips: {
      edit: 'Измена',
      accept: 'Одобри захтев',
      addProccesor: 'Прихватање захтева за обраду',
      complementRequired: 'Потребна допуна',
      decisionCreation: 'Креирај решење',
      downloadProposalSolutiоn: 'Преузми предлог решења',
      createReferenceNumber: 'Унос деловодног броја',
      updateReferenceNumber: 'Измена деловодног броја',
      uploadDecision: 'Приложи решење',
      verifeidDecision: 'Потврди решење',
      downloadDecision: 'Преузми потписано решење',
      sendDecision: 'Пошаљи решење',
      complementRequiredContent: 'Допуна по захтеву',
      deliveredDecision: 'Потврдите достављеност решења',
      saveEdit: 'Поднеси допуњен захтев',
      downloadRequest: 'Преузимање захтева',
      requestStatusRevert: 'Промена статуса захтева',
      decisionStatusRevert: 'Промена статуса решења',
      complementationHistory: 'Преглед историје допуна',
      requestCreatorEdit: 'Промена подносиоца захтева',
    },
    ConfirmDialog: {
      confirmMessageProcessor: 'Да ли желите да прихватите захтев?',
      confirmDeleteProcessor: '',
      confirmMessage: 'Да ли желите да одобрите захтев?',
      confirmDelete: '',
      confirmMessageVerified: 'Да ли желите да потврдите решење?',
      confirmDeleteVerified: '',
      confirmMessageSend: 'Да ли желите да пошаљете решење?',
      confirmDeleteSend: '',
      confirmMessageDelivered: 'Да ли је решење достављено?',
      confirmAltAnswerDelivered: '',
      confirmMessageFinishUpdate: 'Да ли желите да поднесете допуњен захтев?',
      confirmRevertRequestStatusMessage:
        'Да ли заиста желите да вратите захтев у обраду?',
      confirmRevertDecisionStatusMessage:
        'Да ли заиста желите да вратите решење у израду?',
      confirmRequestCreatorChange:
        'Да ли заиста желите да промените подносиоца захтева?',
    },
    NotificationMessages: {
      requestTitle: 'Захтев',
      decisionTitle: 'Решење',
      decisionFinalTitle: 'Потписано решење',
      complementRequiredTitle: 'Потребна допуна захтева',
      complementedTitle: 'Допуњен захтев',
      proposalDecisionTitle: 'Предлог решења',
      decisionTitleError: 'Грешка',
      complementError: 'Грешка',
      successAddProcessor: 'Успешно сте прихватили захтев за обраду',
      successReferenceNumber: 'Успешно сте креирали деловодни број предмета',
      successReferenceNumberUpdate:
        'Успешно сте изменили деловодни број предмета',
      successComplementRequired: 'Успешно сте креирали захтев за допуну',
      successUpdate: 'Успешно сте потврдили допуну захтева',
      saveSuccessUpdate: 'Успешно сте допунили захтев',
      successSubmittedRequest: 'Успешно сте поднели захтев',
      successAcceptRequest: 'Успешно сте одобрили захтев',
      successUploadDecision: 'Успешно сте приложили решење',
      succesVerifiedDecision: 'Успешно сте потврдили решење',
      successDownload: 'Успешно сте преузели документ',
      unsuccessDownload: 'Дошло је до грешке приликом преузимања документа',
      successSent: 'Успешно сте послали документ',
      unsuccessSent: 'Дошло је до грешке приликом слања документа',
      unsuccessMessage: 'Захтев са датим деловодним бројем, већ постоји!',
      succesDeliveredDecision: 'Потврда достављеног решења је успешно извршена',
      draftSuccess: 'Захтев је успешно сачуван',
      successInProcessingRequest: 'Статус захтева је успешно промењен',
      succesInPreparationDecision: 'Статус решења је успешно промењен',
      successUpdateRequest: 'Успешно сте изменили захтев',
    },
  },

  AttachmentTable: {
    name: 'Назив',
    preview: 'Преглед',
    download: 'Преузимање',
    nameUploaded: 'Приложени документи',
    delete: 'Брисање',
  },
  RequestForSignetApprovalFilter: {
    'kjs.name': 'Назив институције',
    'kjs.uniqueNumber': 'Јединствени број КЈС',
    referenceNumber: 'Деловодни број предмета',
    'municipality.name': 'Седиште органа',
    'place.name': 'Град\\Општина',
    createdAtFrom: 'Датум креирања од',
    createdAtTo: 'Датум креирања до',
    'kjs.pib': 'ПИБ',
    status: 'Статус захтева',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },

  KjsFilter: {
    'kjs.uniqueNumber': 'Јединствени број КЈС',
    kjsEntity: 'KJC',
    municipality: 'Седиште органа',
    referenceNumber: 'Деловодни број предмета',
    'municipality.name': 'Седиште органа',
    'place.name': 'Град\\Општина',
    createdAtFrom: 'Датум креирања од',
    createdAtTo: 'Датум креирања до',
    'kjs.pib': 'ПИБ',
    institutionType: 'Тип',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },

  PlaceFilter: {
    autonomousProvince: 'Територијална припадност',
    'municipality.name': 'Седиште органа',
    name: 'Назив града\\општине',
    createdAtFrom: 'Датум креирања од',
    createdAtTo: 'Датум креирања до',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },

  MunicipalityFilter: {
    'place.name': 'Назив града\\општине',
    name: 'Седиште органа',
    createdAtFrom: 'Датум креирања од',
    createdAtTo: 'Датум креирања до',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },

  ModalForCreateRequestApprovalReferenceNumber: {
    Labels: {
      title: 'Креирање деловодног броја захтева',
      titleUpdate: 'Измена деловодног броја захтева',
    },
    Errors: { referenceNumber: 'Потребно је унети деловодни број предмета' },
    Placeholders: {
      referenceNumber: 'Унесите деловодни број предмета...',
      referenceNumberForPreview: 'Деловодни број предмета',
    },
  },

  ModalForUpdateRequestApprovalReferenceNumber: {
    Labels: {
      title: 'Измена деловодног броја предмета',
    },
    Errors: { referenceNumber: 'Потребно је унети деловодни број предмета' },
    Placeholders: {
      referenceNumber: 'Унесите деловодни број предмета...',
      referenceNumberForPreview: 'Деловодни број предмета',
    },
  },

  ModalForUpdateRequestCreator: {
    Labels: {
      title: 'Промена подносиоца захтева',
    },
    Errors: {
      client: 'Потребно је одабрати новог подносиоца захтева',
    },
    Placeholders: {
      client: 'Одаберите новог подносиоца захтева',
    },
  },

  ModalForViewComplementRequestHistory: {
    Labels: {
      title: 'Преглед историје допуна захтева',
    },
  },

  ModalForViewComplementSignetHistory: {
    Labels: {
      title: 'Преглед историје допуне печата',
    },
  },

  ComplementRequestHistoryTable: {
    HeaderColumns: {
      description: 'Напомена',
      creator: 'Обрађивач',
      createdAt: 'Датум промене',
      requestClient: 'Подносилац захтева',
    },
    titleTable: 'Преглед историје напомена',
  },

  ComplementSignetTableHistory: {
    HeaderColumns: {
      description: 'Напомена',
      creator: 'Обрађивач',
      createdAt: 'Датум промене',
    },
    titleTable: 'Преглед историје напомена',
  },

  ModalForAddRequestForSignetStatus: {
    Labels: {
      title: 'Пријава промене статуса печата',
    },
    Errors: {
      status: 'Потребно је изабрати статус',
      uploadedDocument: 'Потребно је приложити документ',
      invalidFileSize: 'Величина фајла је већа од 10MB',
      invalidFormat: 'Фајл мора да буде у .pdf или .docx формату',
    },
    Placeholders: {
      statusSignet: 'Статус печата',
      uploadedDocument: 'Приложите документ',
    },
    NotificationMessages: {
      requestForSignetStatus: 'Промена статуса печата',
      successCreateRequestForSignetStatus:
        'Успешно сте креирали захтев за промену статуса печата',
      successAccepetRequestForSigentStatus:
        'Успешно сте прихватили захтев за промену статуса печата',
    },
  },

  DecisionFilter: {
    decisionStatus: 'Статус решења',
    'decisionType.name': 'Тип решења',
    createdAtFrom: 'Датум креирања решења од',
    createdAtTo: 'Датум креирања решења до',
    kjs: 'КЈС',
    submitDateFrom: 'Датум креирања захтева од',
    submitDateTo: 'Датум креирања захтева до',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },

  SignetProcessingView: {
    Labels: {
      title: 'Обрада печата',
      actionTitle: 'Акције',
      documentTitle: 'Документи',
      requestForSignetStatusTitle: 'Документи пријаве промене статуса печата',
    },
    Placeholders: {
      request: 'Захтев',
      organizationalUnit: 'Орган',
      plannedStart: 'Датум набавке',
      statusChangedDate: 'Датум промене статуса',
      beginOfUsage: 'Почетак употребе',
      authorizedPerson: 'Овлашћено лице',
      signetState: 'Стање',
      signetStatus: 'Статус',
      uniqueSerialNumber: 'Јединствени серијски број',
      validUntil: 'Крај употребе',
      sigentState: 'Стање печата',
      sigentStatus: 'Статус печата',
      notificationStartFrom: 'Почетак важења печата је за: ',
      days: ' дана',
      day: ' дан',
    },
    Value: {
      validate: 'Валидирано',
    },
    Tooltips: {
      showRequest: 'Преглед захтева',
      showAttachmentRequest: 'Преглед прилога',
      complementSignet: 'Достављање података о израђеним печатима',
      changeState: 'Промена стања',
      complementRequired: 'Потребна допуна',
      complementSignetContent: 'Садржај потребне допуне',
      approve: 'Заврши печат',
      reject: 'Одбаци печат',
      requestForSignetStatus: 'Пријава промене статуса печата',
      acceptRequestForSignetStatus: 'Прихватање пријаве промене статуса печата',
      acceptComplemened: 'Потврда достављених података',
      updateComplementSignet:
        'Измена достављених података о израђеним печатима',
      downloadExample: 'Преузмите спољни приказ електронског печата',
      requestPreview: 'Преглед захтева',
      uploadSignetDestroyed: 'Учитавање записника о уништењу печата',
      complementationHistory: 'Преглед историје допуна',
    },
    ConfirmDialog: {
      confirmMessage: 'Да ли заиста желите да промените стање печата у',
      confirm: ', промени',
      confirmApproveMessage: 'Да ли заиста желите да завршите печат?',
      confirmRejectMessage: 'Да ли заиста желите да одбаците печат?',
      confirmAcceptRequestForSignetStatus:
        'Да ли заиста желите да прихватите промену статуса печата?',
      confirmComplementedMessage:
        'Да ли заиста желите да потврдите промене података о израђеним печатима?',
    },
    NotificationMessages: {
      signet: 'Печат',
      complementSignet: 'Допуна',
      complementError: 'Грешка',
      requestForSignetStatus: 'Промена статуса печата',
      submissionDataSignet: 'Достављање података о израђеним печатима',
      complementationSignet: 'Потребна допуна достављених података',
      successComplementRequired: 'Успешно сте креирали захтев за допуну',
      successComplementedSubmission:
        'Успешно сте доставили податке о израђеном печату',
      successSubmissionDataCreate:
        'Успешно сте доставили податке о израђеном печату',
      successSubmissionDataUpdate:
        'Успешно сте сачували податке о израђеном печату',
      successAcceptSignet: 'Успешно сте завршили печат',
      unsuccessSubmissionData:
        'Печат са датим јединственим серијским бројем, већ постоји!',
      successCreateRequestForSignetStatus:
        'Успешно сте креирали захтев за промену статуса печата',
      successAccepetRequestForSigentStatus:
        'Успешно сте прихватили захтев за промену статуса печата',
      successDownloadExample:
        'Успешно сте преузели спољни приказ електронског печата органа',
      unsuccessDownload: 'Дошло је до грешке приликом преузимања документа',
      successSignetDestroyedUpload: 'Документ је успешно учитан',
      unsuccessSignetDestroyedUpload:
        'Дошло је до грешке приликом учитавања документа',
      uploadSignetDestroyed: 'Учитавање записника о уништењу печата',
      unsuccessfulDownload: 'Дошло је до грешке приликом преузимања документа',
    },
  },
  ModalWithPredefinedUsers: {
    Labels: {
      title: 'Изаберите корисника',
    },
    Placeholders: {
      coatOfArmsAppearance: 'Корисници',
    },
    Errors: {
      user: 'Потребно је изабрати корисника !',
    },
  },

  ModalForPreviewRequestApproval: {
    Labels: {
      title: 'Преглед захтева',
    },
    Placeholders: {},
  },

  KjsList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  KjsTable: {
    HeaderColumns: {
      identificationNumber: 'Матични број',
      name: 'Назив',
      uniqueNumber: 'Јединствени број КЈС',
      pib: 'ПИБ',
      municipality: 'Седиште органа',
      institutionType: 'Тип органа',
      update: 'Измена назива',
      updateMunicipality: 'Измена седишта органа',
      activateDeactivate: 'Активирај/Деактивирај',
      user: 'Корисник',
    },
    ConfirmDialog: {
      confirmMessage: 'Да ли заиста желите да покренете синхронизацију за КЈС?',
      confirmActivateMessage: 'Да ли заиста желите да активирате КЈС?',
      confirmDeactivateMessage: 'Да ли заиста желите да деактивирате КЈС?',
      deactivate: ', деактивирај!',
      activate: ', активирај!',
    },
    titleTable: 'Корисници јавних средстава',
    synchronization: 'Синхронизација КЈС',
    Tooltips: {
      update: 'Измена назива',
      updateMunicipality: 'Промена седишта органа',
    },
    NotificationMessages: {
      kjs: 'KЈС',
      kjsUpdateNameSuccessefully: 'Успешно сте променили назив КЈС-а',
      kjsUpdateMunicipalitySuccessefully:
        'Успешно сте променили седиште органа КЈС-а',
      kjsActivateSuccessefully: 'Успешно сте активирали КЈС',
      kjsDeactivateSuccessefully: 'Успешно сте деактивирали КЈС',
    },
  },

  ModalForUpdateKjsName: {
    Labels: {
      title: 'Промена назив КЈС-a',
    },
    Placeholders: {
      kjsName: 'Назив КЈС-a',
    },
  },

  ModalForUpdateKjsMunicipality: {
    Labels: {
      title: 'Промена седишта органа',
    },
    Errors: {
      kjs: 'Потребно је унети КЈС.',
      municipality: 'Потребно је унети седиште органа.',
    },
    Placeholders: {
      place: 'Град\\Општина',
      municipality: 'Седиште органа',
      institutionType: 'Тип органа',
      pib: 'ПИБ',
      uniqueKjsNumber: 'Јединствени број КЈС',
      kjs: 'КЈС',
    },
  },

  PlaceList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  PlaceTable: {
    HeaderColumns: {
      name: 'Назив',
      autonomousProvince: 'Територијална припадност',
      addAutonomousProvince: 'Изаберите територијалну припадност',
      updatePlace: 'Измена места',
    },
    titleTable: 'Град\\Општина',
    Tooltips: {
      addPlace: 'Додај место',
      updatePlaceName: 'Промени назив места',
      updateAutonomousProvnice: 'Додај територијалну припадност',
    },
    NotificationMessages: {
      place: 'Meстo',
      addPlaceSuccessfully: 'Успешно сте додали ново место',
      updatePlaceSuccessfully: 'Успешно сте изменили место',
    },
  },

  MunicipalityList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  MunicipalityTable: {
    HeaderColumns: {
      name: 'Назив',
      place: 'Град\\Општина',
      addPlace: 'Изаберите град\\општину',
      updateMunicipality: 'Измена седишта органа',
    },
    titleTable: 'Седиштe органа',
    Tooltips: {
      addMunicipality: 'Додај седиште органа',
      updateMunicipality: 'Промени назив седиштa органа',
      updatePlace: 'Додај место',
    },
    NotificationMessages: {
      municipality: 'Седиштe органа',
      addMunicipalitySuccessfully: 'Успешно сте додали ново седиште органа',
      updateMunicipalitySuccessfully: 'Успешно сте изменили седиште органа',
    },
  },

  ModalForAddMunicipalityToPlace: {
    Labels: {
      title: 'Додавање места седиштa органа',
      titleUpdate: 'Промена места седиштa органа',
    },
    Placeholders: {
      place: 'Место',
    },
    Errors: {
      place: 'Потребно је одабрати место',
    },
  },

  ModalForUpdateMunicipalityName: {
    Labels: {
      titleUpdate: 'Промена назива седиштa органа',
      title: 'Додавање седишта органа',
    },
    Placeholders: {
      name: 'Назив седишта органа',
      place: 'Место',
    },
    Errors: {
      name: 'Потребно је унети назив седишта органа',
      place: 'Потребно је одабрати место седишта органа',
    },
  },

  MunicipalityRow: {
    Tooltips: {
      updatePlace: 'Додајте место',
      updateMunicipality: 'Промени седиште органа',
    },
  },

  ModalForAddOrUpdatePlace: {
    title: 'Модал за додавање места',
    Placeholders: {
      placeName: 'Назив места',
    },
    Errors: {
      placeName: 'Потребно је унети назив места',
    },
  },

  PlaceRow: {
    Tooltips: {
      autonomousProvince: 'Изаберите територијалну припадност',
    },
  },
  ModalForUploadSignetDestroyedAttachment: {
    Labels: {
      title: 'Учитавање записника о уништењу печата',
    },
    Placeholders: {
      uploadSignetDestroyed: 'Учитајте записник о уништењу печата',
    },
  },

  SignetExampleList: {
    rowPerPage: 'Број редова',
    of: ' од ',
  },

  SignetExampleTable: {
    Labels: { titleTable: 'Спољни приказ електронског печата' },
    HeaderColumns: {
      name: 'Назив',
      preview: 'Преглед',
      download: 'Преузимање',
    },
    Tooltips: {
      addNew: 'Учитајте нови документ',
    },
    NotificationMessages: {
      signetExample: 'Спољни приказ електронског печата',
    },
  },
  ModalForUploadSignetExample: {
    Labels: {
      title: 'Учитавање спољног приказа електронског печата',
    },
    Placeholders: {
      uploadSignetDestroyed: 'Учитајте спољни приказ електронског печата',
    },
    Errors: {
      imageNotUploaded: 'Фајл није учитан',
      invalidFileSize: 'Величина фајла је већа од 10MB',
      invalidFormat: 'Фајл мора да буде у .pdf или .docx формату',
    },
  },
  SignetExampleRow: {
    NotificationMessages: {
      signet: 'Спољни приказ електронског печата',
      successDownloadExample:
        'Успешно сте преузели спољни приказ електронског печата',
      unsuccessfulDownload: 'Дошло је до грешке приликом преузимања документа',
    },
  },
  ModalForDocumentPreview: {
    filePreviewTitle: 'Грешка',
  },

  UnauthorizedAccess: {
    cardTitle:
      'Немате право приступа систему, молимо вас да се обратите администратору на адресу ',
    Email: {
      subject: 'Saglasnost za pečat - pristup',
      body:
        'Poštovani,%0D%0A%0D%0AIzmenama i dopunama Zakona o pečatu državnih i drugih organa ("Službeni glasnik RS", broj 101/2007 i 49/2021) predviđena je upotreba kvalifikovanog elektronskog pečata čime se omogućava izdavanje akata organa u elektronskom obliku.%0D%0AZahtev za saglasnost na elektronski pečat podnosi rukovodilac organa.%0D%0AUkoliko rukovodilac organa ovlasti neko drugo lice za podnošenje zahteva za elektronski pečat potrebno je da uz zahtev za registraciju, dostavite skenirano ovlašćenje rukovodioca organa za to lice.%0D%0A%0D%0APodaci o organu%0D%0A%0D%0ANaziv organa:%0D%0AGrad/Opština:%0D%0ASedište organa:%0D%0A%0D%0APodaci o ovlašćenom licu%0D%0A%0D%0AJMBG:%0D%0AIme:%0D%0APrezime:%0D%0AImejl:%0D%0A%0D%0ASkeniran dopis sa podacima o organu i ovlašćenom licu prosledite nam putem imejla epecat.mduls@mduls.gov.rs.',
    },
  },
  KJSMunicipalityTable: {
    kjs: 'КЈС',
    delete: 'Брисање',
  },

  UserFilter: {
    firstName: 'Име',
    lastName: 'Презиме',
    role: 'Улога',
    kjs: 'КЈС',
    municipality: 'Седиште органа',
    AccordionForm: {
      reset: 'Обриши',
      filter: 'Филтрирај',
      title: 'Филтери',
    },
  },
};
